/** Situações da Condição de Pagamento */
export interface CondicaoPagamentoSituacao {
    id: number;
    nome: string;
}

export const condicaoPagamentoAtiva: CondicaoPagamentoSituacao = {id: 1, nome: 'Ativa'};
export const condicaoPagamentoInativa: CondicaoPagamentoSituacao = {id: 2, nome: 'Inativa'};

export const condicaoPagamentoSituacoes: CondicaoPagamentoSituacao[] = [
    condicaoPagamentoAtiva,
    condicaoPagamentoInativa
];

/** Verifica se a situação da condição de pagamento é Ativa */
export function isCondicaoPagamentoSituacaoAtiva(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === condicaoPagamentoAtiva.id;
}


/** Verifica se a situação da condição de pagamento é Inativa */
export function isCondicaoPagamentoSituacaoInativa(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === condicaoPagamentoInativa.id;
}
